















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ColorPicker from "@/commonComponents/colorPicker/colorPicker.vue";

import * as def from "@/definitions";

import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { TableLayer } from "@/model/document2/page/surface/design/layer/tableLayer";

import { ColorConstruct } from "@/utilityModels/colorConstruct";

// import CustomInput from '@/commonComponents/customInput/customInput.vue';

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    ColorPicker,
    ValueEdit,
    ColorSelector,
    AdjustedBalloon,
    ArrowDown,
    ArrowRight,
    CheckBoxOn
  }
})
export default class TableCell extends Vue {
    @Prop() private layer!: TableLayer;

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend: true
    };

    tableCellContentsOpenAnimate = false;
    tableCellContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
            this.tableCellContentsCloseAnimate = true;
            setTimeout(() => {
                this.tableCellContentsCloseAnimate = false;
                this.tableCellContentsOpenAnimate = false;
                this.openStatus.opend = false;
            }, 200);
        } else {
            this.openStatus.opend = true;
            this.tableCellContentsOpenAnimate = true;
            setTimeout(() => {
                this.tableCellContentsOpenAnimate = false;
            }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    //↓↓↓↓↓カラーピッカー表示非表示↓↓↓↓↓
    //こいつはpropsでいらない
    isBackgroundColorPickerVisible = false;
    showBackgroundColorPicker() {
        this.isBackgroundColorPickerVisible = true;
    }
    closeBackgroundColorPicker() {
        this.isBackgroundColorPickerVisible = false;
    }
    //↑↑↑↑↑カラーピッカー表示非表示↑↑↑↑↑

    //↓↓↓↓↓色↓↓↓↓↓

    get backgroundColor(): ColorConstruct 
    {
        return this.layer.getCurrentCellInfo().backgroundColor;
    }

    get backgroundColorStyle() 
    {
        return {
            background: this.layer.getCurrentCellInfo().backgroundColor.hex
        };
    }

    // 色変更中
    private onChangingColor(color, tag) 
    {
        this.changeCellInfo(color, tag, false, false);
    }
    // 色変更完了
    private onChangedColor(color, tag) 
    {
        this.changeCellInfo(color, tag, true, false);
    }

    //↑↑↑↑↑色↑↑↑↑↑

    // セル追加
    private clickAddCell(direction : number)
    {
        this.$emit("doCommand", "addTableCell", { layer : this.layer, direction : direction });
    }

    // セル削除
    private clickDeleteCell(isDeleteRow : boolean, isDeleteColumn : boolean)
    {
        this.$emit("doCommand", "deleteTableCell", { layer : this.layer, isDeleteRow : isDeleteRow, isDeleteColumn : isDeleteColumn });
    }

    // セルの色を適用
    private clickApplyCellColor(isRow : boolean, isColumn : boolean)
    {
        this.$emit("doCommand", "applyCellColor", { layer : this.layer, isRow : isRow, isColumn : isColumn });
    }

    // セル高さ
    private get cellHeight()
    {
        return this.layer.getCurrentCellInfo().cellHeightNormalized * this.layer.height / 100;
    }

    // セル幅
    private get cellWidth()
    {
        return this.layer.getCurrentCellInfo().cellWidthNormalized * this.layer.width / 100;
    }

    private onChangingValue(value : number, tag : string)
    {
        if(tag == "cellHeight")
        {
            this.$emit("doCommand", "changeTableCellHeight", { layer : this.layer, value : value, isFinish : false });
        }
        else if(tag == "cellWidth")
        {
            this.$emit("doCommand", "changeTableCellWidth", { layer : this.layer, value : value, isFinish : false });
        }
    }

    private onChangedValue(value : number, tag: string)
    {
        if(tag == "cellHeight")
        {
            this.$emit("doCommand", "changeTableCellHeight", { layer : this.layer, value : value, isFinish : true });
        }
        else if(tag == "cellWidth")
        {
            this.$emit("doCommand", "changeTableCellWidth", { layer : this.layer, value : value, isFinish : true });
        }
    }

    private changeLayerProperty(
        value: any,
        propertyName: string,
        isFinish: boolean = false,
        isOnce: boolean = false
    ) 
    {
        this.$emit("doCommand", "changeLayerProperty", {
            layer: this.layer,
            propertyName: propertyName,
            value: value,
            isFinish: isFinish,
            isOnce: isOnce
        });
    }

    private changeCellInfo(value : any, propertyName : string, isFinish : boolean = false, isOnce : boolean = false)
    {
        this.$emit("doCommand", "changeTableCellInfo", { layer : this.layer, propertyName : propertyName, value : value, isFinish : isFinish, isOnce : isOnce });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
